export default __webpack_public_path__ + "static/media/search.dea66414.png";